export default {
  meetingsMetadata: {
    roles: {
      participant: 'My meetings',
      supervisor: 'I assigned',
    },
    statuses: {
      planned: 'Planned',
      done: 'Done',
      overdue: 'Overdue',
      cancelled: 'Cancelled',
      new: 'New',
      inProgress: 'In progress',
      ready: 'Done',
    },
    formats: {
      online: 'Online',
      offline: 'Offline',
    },
    statusesDescriptions: {
      planned: 'The meeting is scheduled, you can reschedule the meeting for another time and date',
      done: 'The meeting is over, you can specify the results, as well as add tasks to yourself and the employee',
      overdue: 'The meeting has expired, you can reschedule the meeting for another time and date',
      cancelled: 'The meeting was canceled',
    },
    buttons: {
      addAnotherQuestion: 'Add another question',
      goToMeeting: 'Go to the meeting',
      viewTasks: 'View tasks',
      doneMeeting: 'Done the meeting',
      cancelMeeting: 'Cancel the meeting',
      addTask: 'Add a task',
      removeTask: 'Delete the task',
      doneTasks: 'Done the meeting and add a tasks',
      cancel: 'Yes, done',
      confirmDone: 'Yes, done',
      confirmContinue: 'Yes, continue',
      confirmAdd: 'Yes, add',
      confirmRemove: 'Yes, remove',
    },
    agenda: 'Agenda',
    myTasks: 'My tasks',
    tasksForEmployee: 'Tasks for the employee',
    tasksForSupervisor: 'Tasks for the supervisor',
    meetingRoom: 'Meeting room',
    resultsMeeting: 'Results of the meeting',
    listOfQuestions: 'List of questions',
    createMeeting: 'Schedule a meeting',
    role: 'Role',
    formLabels: {
      type: 'Type of meeting',
      supervisor: 'Supervisor of the meeting',
      employee: 'Employee',
      date: 'Date',
      time: 'Time',
      format: 'Format',
      link: 'Link',
      agenda: 'Agenda',
      summary: 'Results of the meeting',
      summarySupervisor: 'Results of the meeting of the supervisor',
      theme: 'Theme',
      question: 'Question',
      name: 'Name of the task',
      deadline: 'Deadline',
      importance: 'Importance',
    },
    confirmDoneMeeting: {
      title: 'Are you sure you want to done the meeting?',
      text: 'After the done of the meeting, it will not be possible to reschedule. You can summarize the meeting now or later.',
    },
    cancelMeeting: 'Cancel the meeting?',
    successMessages: {
      createMeeting: 'The meeting successfully created',
      changeMeeting: 'The meeting successfully changed',
      addQuestions: 'The questions successfully added',
      rescheduleMeeting: 'The meeting successfully rescheduled',
      doneMeeting: 'The meeting status successfully changed',
      cancelMeeting: 'The meeting successfully cancelled',
      deleteTask: 'The task successfully deleted',
      changeShowTask: 'The visibility of the task on a board successfully changed',
      createTask: 'The task successfully created',
    },
    errorMessages: {
      createMeeting: 'Failed to create the meeting',
      changeMeeting: 'Failed to change the meeting',
      addQuestions: 'Failed to add the questions',
      rescheduleMeeting: 'Failed to reschedule the meeting',
      doneMeeting: 'Failed to change the meeting status',
      cancelMeeting: 'Failed to cancel the meeting',
      deleteTask: 'Failed to delete the task',
      changeShowTask: 'Failed to change visibility of the task on a board',
      createTask: 'Failed to create task',
    },
    tableHeaders: {
      name: 'Name',
      theme: 'Theme',
      employee: 'Employee',
      position: 'Position',
      team: 'Team',
    },
    deleteQuestion: 'Delete the question?',
    noQuestions: "You haven't added any questions yet",
    confirmDeleteTask: {
      title: 'Delete the task?',
      text: 'The task will be removed from the meeting and from the board',
    },
    changeShowTask: {
      show: 'Add the task to a board?',
      notShow: 'Remove the task from a board?',
    },
    noTasks: 'No tasks',
    tooltips: {
      addTask: 'Add the task to the board',
      removeTask: 'Remove the task from the board',
      deleteTask: 'Delete the task',
      participant: "I'm an employee",
      supervisor: "I'm a supervisor",
    },
    addQuestionsTitle: 'Add a questions',
    tabs: {
      basic: 'Basic questions',
      new: 'New question',
    },
    title: 'Comment',
    question: 'Question',
    labels: 'Comments',
    dialogTitle: 'New task',
    placeholders: {
      selectStatus: 'Select a status',
      selectRole: 'Select a role',
    },
    noMeetings: 'No meetings have been scheduled yet',
    roleParticipant: 'Employee',
    roleSupervisor: 'Supervisor',
    linkOnMeeting: 'Link to the meeting',
  },
};
